var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"CreditCardView\">\n<div class=\"CreditCardView-details\" ng-show=\"card\">\n<table class=\"CreditCardView-detailsTable\">\n<tr>\n<th>{{ 'COMPONENT.CREDIT_CARD_VIEW.CARD_TYPE' | translate }}</th>\n<td>{{card.brand}}</td>\n</tr>\n<tr>\n<th>{{ 'COMPONENT.CREDIT_CARD_VIEW.CARD_NUMBER' | translate }}</th>\n<td>XXXX XXXX XXXX {{card.last4}}</td>\n</tr>\n<tr>\n<th>{{ 'COMPONENT.CREDIT_CARD_VIEW.EXPIRY' | translate }}</th>\n<td>{{card.exp_month}}/{{card.exp_year}}</td>\n</tr>\n</table>\n</div>\n<div ng-show=\"showUpdate\" class=\"CreditCardView-actionsContainer\">\n<ike-button ng-click=\"toggle()\">{{ 'COMPONENT.CREDIT_CARD_VIEW.CLOSE' | translate }}</ike-button>\n<ike-button class=\"CreditCardView-updateButton\" ng-click=\"openUpdate()\">{{ 'COMPONENT.CREDIT_CARD_VIEW.UPDATE' | translate }}</ike-button>\n</div>\n</div>\n";
var id1="credit.card.view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/credit.card.view.html
// module id = 485
// module chunks = 0